import { YouTube } from "@mui/icons-material";
import { Fab, Tooltip, Zoom } from "@mui/material";
import React from "react";
import YoutubeVideoDialog from "../Dialogs/YoutubeVideoDialog";

const YouTubeFloating = ({ position = "bottom", videoLink }) => {
  const [openYoutubeDialog, setOpenYoutubeDialog] = React.useState(false);

  return (
    <>
      <YoutubeVideoDialog
        open={openYoutubeDialog}
        handleCloseDialog={() => setOpenYoutubeDialog(false)}
        videoLink={videoLink}
      />

      <Tooltip
        title="Watch Tutorial Videos"
        arrow
        placement="left"
        TransitionComponent={Zoom}
      >
        <Fab
          size="medium"
          aria-label="youtube videos"
          sx={{
            position: "fixed",
            bottom: position === "bottom" ? "90px" : "auto",
            top: position === "top" ? "20px" : "auto",
            right: "18px",
            width: 44,
            height: 44,
            backgroundColor: "#FF0000",
            color: "white",
            boxShadow: "0 4px 12px rgba(255, 0, 0, 0.3)",
            transition: "all 0.3s ease",
            zIndex: 1300,
            "&:hover": {
              backgroundColor: "#CC0000",
              transform: "scale(1.1)",
              boxShadow: "0 6px 20px rgba(255, 0, 0, 0.4)",
            },
            "&:active": {
              transform: "scale(0.95)",
            },
          }}
          onClick={() => {
            setOpenYoutubeDialog(true);
          }}
        >
          <YouTube sx={{ fontSize: 30 }} />
        </Fab>
      </Tooltip>
    </>
  );
};

export default YouTubeFloating;
